/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { FieldFabFamilyInformationModule } from './field-fab-family-information.module';
export { FieldFabFamilyInformation } from './field-fab-family-information.component';